import React from 'react';
import type { PagesQuery } from '../../graphql/generated/schema';
import type { ExtractLayoutType, SharedBlockType } from '../types';
import styles from './styles.module.scss';

export const Spacer: React.FC<SharedBlockType & ExtractLayoutType<PagesQuery, 'Spacer'>> = ({
  height,
}) => (
  <div
    className={styles.spacer}
    style={{
      height: height || 0,
    }}
  />
);
